<template>
<Forms ref="frmSearch"
        title="Busca por Cadastro"
        :showHelp="true"
        :showClearButton="true"
        :showSearchButton="true"
        :showNewButton="true"
        :ShowFooterImbo="true"
        :showSearchIcon="true"
        v-on:Clear="onClearSection"
        v-on:Search="Search"
        style="font-family: 'Segoe UI';"
        >
        <div class="form-inputs">
            <label class="labelsearch">Categoria</label>
            <multiselect
                v-model="forms.listagemInterna"
                :options="listagem"
                :multiple="true"
                :taggable="true"
                placeholder="Selecione uma categoria"
                label="nome"
                track-by="nome"
                selectLabel=""
                deselectLabel=""
                selectedLabel=""
                :showLabels="false"
                :close-on-select="false"
                >
              </multiselect>
        </div>
        <div class="form-inputs">
            <label class="labelsearch">Descrição</label>
            <b-form-textarea v-model="forms.descricao"  placeholder="Informe a descrição" :rows="6"/>
        </div>
</Forms>
</template>

<script>
import registerFilter from './registerFilter'
export default registerFilter
</script>

<style>
.form-inputs{
    width: 100%;
    padding: 0.5rem 0;
}
.labelsearch{
    font-weight: 700;
    color: #666;
    font-size: 14px;
    margin-bottom: 5px;
    padding-bottom: 0;
    font-family: 'Segoe UI';
}

.multiselect__option {
  font-family: 'Segoe UI', sans-serif;
  font-size: 14px;
  color: #333;
}

.multiselect__option--highlight {
  font-size: 14px;
  background-color: #f0f0f0;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/views/private/apr/registerApr/components/registerFilter/registerFilter.vue